import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddExpenseTypeResponse,
  ExpenseTypePayload,
  ExpenseTypeResponse,
} from '@core/interface/expense-type';
import { PagePayload } from '@core/interface/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ExpenseTypeService {
  constructor(private http: HttpClient) {}

  getExpenseTypes(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<ExpenseTypeResponse>(
      environment.endPoints.expenseTypeList,
      { params: httpParams }
    );
  }

  addExpenseType(data: ExpenseTypePayload) {
    return this.http.post<AddExpenseTypeResponse>(
      environment.endPoints.expenseTypeAddEdit,
      data
    );
  }
}
